import React from 'react';

const ConfiguratorControlButtons = props => {
  const { toggleOpen, toggleDimensions, opened, dimensions } = props;

  return (
    <div className="control-buttons">
      <button
        className={`control-buttons__btn ${opened ? 'active' : ''}`}
        title="Otwórz/zamknij"
        onClick={toggleOpen}>
        <span className="icon-open-door" />
      </button>
      <button
        className={`control-buttons__btn ${dimensions ? 'active' : ''}`}
        title="Pokaż wymiary"
        onClick={toggleDimensions}>
        <span className="icon-measurements" />
      </button>
    </div>
  );
};

export default ConfiguratorControlButtons;
